<ng-container>
    <mat-card class="no-data" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon class="width-80 height-80 font-size-80">sentiment_very_dissatisfied</mat-icon>
        <b class="p-3">{{ 'Global.NotFoundData' | translate }}</b>
    </mat-card>
</ng-container>